<template>
    <li @click="$emit('click', $event)" itemscope itemtype="https://schema.org/Product"
        class="lazy-hover product-list-item">
        <meta itemprop="brand" content="Chico Rei"/>
        <meta itemprop="sku" :content="product.id ? product.id : product._id"/>

        <a target="_self" :href="productLink" itemprop="url" :content="product.link">

            <div class="product-list-item-image-hover rounded overflow-hidden aspect bg-default-1"
                 :class="{'aspect-xs-4-5': shorterImage, 'aspect-shirt': !shorterImage}"
                 rel="1">
                <div class="pos-absolute pos-all">
                    <img src=""
                         itemprop="image"
                         class="product-list-item-photo lazy lazy-fade w-full"
                         :class="{'h-full': shorterImage && product.type.id !== 1}"
                         border="0"
                         :alt="product.name"
                         :data-src="image"/>
                    <img v-if="!hideArtImage" src="" class="product-list-item-art lazy lazy-fade" border="0"
                         :alt="'Estampa ' + product.name" :data-src="imageArt"/>
                    <img v-if="!hideArtImage && selectedFabric" class="product-list-item-art" border="0"
                         :alt="'Estampa ' + product.name" :src="imageArt"/>
                </div>

                <div class="product-list-item-colors"
                     v-if="fabricsToPreview" @mouseleave="selectedFabric = null">
                    <div class="product-list-item-color"
                         :style="{'background-color': fabric.hexa}"
                         v-for="fabric in fabricsToPreview"
                         @mouseenter="selectedFabric = fabric"></div>
                </div>

                <div class="pos-absolute pos-bottom pos-right mr-2 mb-2">
                    <ProductListItemSeal
                        :product="product"
                        :show-discount="!!(options.displayPrice && options.displayPercent)"
                        :show-promo="displayPromoBadge"/>
                </div>
            </div>

            <slot name="below-image"></slot>

            <p v-if="!options || options.displayName" class="product-list-item-title" itemprop="name">
                {{ product.name }}
            </p>
            <meta v-else itemprop="name" :content="product.name"/>

            <div class="product-list-item-info" itemprop="offers" itemscope itemtype="http://schema.org/Offer">
                <link itemprop="url" :href="product.link"/>
                <link itemprop="itemCondition" href="http://schema.org/NewCondition"/>

                <template v-if="options && options.displayPrice && product.in_stock">
                    <ProductCatalogPrice :product="product" :options="options"/>

                    <p v-if="(!options  || !options.hideInstallments) && product.price_min == product.price_max && product.price >= 20 && $scope.IS_REGULAR_CUSTOMER">
                        4x de R${{ (product.price / 4) | formatPrice }}
                    </p>
                </template>
                <template v-else-if="options && options.displayPrice">
                    <meta :content="product.price_min > 0 ? product.price_min : product.price" itemprop="price">
                    <meta itemprop="priceCurrency" content="BRL"/>
                    <p>
                        Indisponível
                    </p>
                </template>
                <template v-else>
                    <meta :content="product.price_min > 0 ? product.price_min : product.price" itemprop="price">
                    <meta itemprop="priceCurrency" content="BRL"/>
                </template>
                <link itemprop="availability"
                      :href="'http://schema.org/' + ((product.quantity > 0 || product.virtual_stock) ? 'InStock' : 'OutOfStock')"/>
            </div>

            <slot></slot>
        </a>

        <slot name="outside-link"></slot>
    </li>
</template>

<script>
    import {getProductThumbLink} from "../../../common/common";
    import ProductCatalogPrice from "./ProductCatalogPrice";
    import ProductListItemSeal from "./ProductListItemSeal";

    export default {
        name: "ProductListItem",
        components: {ProductListItemSeal, ProductCatalogPrice},
        props: {
            product: {
                type: Object,
                required: true
            },
            options: {
                type: Object,
                default: () => ({})
            },
            gender: {
                type: Number,
                default: 0,
            },
            fabric: {
                type: Number,
                default: 0,
            },
            selectedFilters: {
                type: Object
            },
            shorterImage: Boolean
        },

        data() {
            return {
                selectedFabric: null,
            }
        },

        filters: {
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            }
        },

        computed: {
            productLink() {
                let url = new URL(this.$scope.URL + this.product.link.substr(1));

                if (this.selectedFilters) {
                    if (['M', 'F'].indexOf(this.selectedFilters.gender) !== -1) {
                        url.searchParams.set('gender', this.selectedFilters.gender);
                    }

                    if (this.selectedFilters.inPhysicalStock === 1) {
                        url.searchParams.set('inPhysicalStock', this.selectedFilters.inPhysicalStock);
                    }

                    if (this.selectedFilters.size) {
                        url.searchParams.set('size', this.selectedFilters.size);
                    }
                }

                if (this.selectedFabric) {
                    url.searchParams.set('fabric', this.selectedFabric.id);
                }

                return url.toString();
            },

            imageArt() {
                if (parseInt((this.product.type || {}).id) === 6)
                    return this.image;

                try {
                    if (this.hideArtImage) {
                        return null;
                    }

                    return getProductThumbLink(this.product.img_thumb, this.product.img_thumb_png, this.selectedFabric ? this.selectedFabric.id : this.fabric,
                        {
                            'auto': 'format',
                            'lossless': 1,
                            'fit': 'crop',
                            'w': this.options && this.options.imageWidth ? this.options.imageWidth : null,
                            'h': this.options && this.options.imageHeight ? this.options.imageHeight : null
                        });
                } catch (err) {
                    return console.warn(err);
                }
            },

            image() {
                try {
                    if (this.options && this.options.displayModel !== undefined && !this.options.displayModel && this.imageArt) {
                        return this.imageArt;
                    }

                    let url = (this.gender === 2 && this.product.img_female != null ? this.product.img_female : (this.gender === 1 && this.product.img_male != null ? this.product.img_male : this.product.img_cover));

                    return this.croppedImage(url);
                } catch (err) {
                    return null;
                }
            },

            hideArtImage() {
                return !this.options || !this.options.displayArt || parseInt((this.product.type || {}).id) === 6;
            },

            displayPromoBadge() {
                if (!this.$scope.IS_REGULAR_CUSTOMER) return false;

                return !this.product.promo_group || !this.options || !this.options.userGroups || this.options.userGroups.indexOf(this.product.promo_group) !== -1;
            },

            fabricsToPreview() {
                if (!this.options.displayColors || (this.product.fabrics || []).length <= 1) return null;
                return this.product.fabrics.filter(f => this.product.fabric_id !== f.id).slice(0, 5);
            }
        },

        methods: {
            croppedImage(url) {
                url = new URL(url);
                url.searchParams.set('auto', 'format');
                url.searchParams.set('lossless', 1);
                url.searchParams.set('fit', 'crop');

                if (this.options && this.options.imageWidth) {
                    url.searchParams.set('w', this.options.imageWidth);
                }

                if (this.options && this.options.imageHeight) {
                    url.searchParams.set('h', this.options.imageHeight);
                }

                return url.toString();
            },
        }
    }
</script>